import { ClientEnvironment } from '@thehubz/client/core';
import { CustomClients, CustomClientsTitle } from '@thehubz/shared/branding';
import { termsAndConditions } from './terms-and-conditions';

export const environment: Partial<ClientEnvironment> = {
  production: false,

  // eslint-disable-next-line @typescript-eslint/no-var-requires
  appVersion: require('../../../../../../../package.json').version,
  appTitle: '',
  environment: 'DEV',

  brandingKey: CustomClients.LufthansaMedialounge,
  brandingTitle: CustomClientsTitle.LufthansaMedialounge,
  apiBasePath: 'https://lufthansa-medialounge.test.serviceplanmakeos.com',
  fileAccessUrl: 'https://lufthansa-medialounge.test.serviceplanmakeos.com/api/file-access',
  s3Config: {
    bucket: 'makeos-medialounge-test-assets',
  },
  idleTimeout: 240,
  termsConditionsPopup: {
    onAssetDownload: true,
    content: termsAndConditions,
  },
  exportUserReportDownload: {
    fileName: 'LH_Media_Lounge_user_report',
    addTime: true,
  },
  assetDownload: {
    excludeFormat: ['gen-thumbnail', 'gen-preview', 'gen-preview-xl', 'pdf-preview', 'gen-convert'],
    sortFormatsBy: 'size',
  },
  footerPages: {
    showFooter: true,
  },
  publicSharing: {
    mode: 'always',
    baseUrl: 'https://lufthansa-medialounge.test.serviceplanmakeos.com/share/en',
    emailMandatory: true,
  },
  assetStatusIcon: true,
  feature: {
    tagGroups: true,
  },
  brandConfig: {
    navigation: {
      imprintUrl: 'https://www.lufthansagroup.com/de/service/impressum.html',
    },
  },
  captchaApiKey:
    'r+WQWjD1Cdj82Tq3Taqy40522ZJ+JjWe/LY7Lac5+lSJk4H0iRFZJBlAOqLvvZfrLe6Ls7jhRRi8rM6OaX2Chs6hx1Ge48k2MbJTALJctn2iS/MxVTOAotonWPIrUEmOdgsjPupCKQrvDNVpdP77HyqnZ8Sm9zG7JD5kJTx03ZBCqCYlMPzVvAUhd0D5WpclXWUhwcmEj2AvekrkwwS02Ohkb1+Ikb4BOB61a9nrvBGIpWxsgGEmmoQdWrfq5hqBfkCnRPtDOgsIv2+XK2KCxN1reLBP3W4aNNVqIDR5uKjIVY4+zKYM0JAcbntHIm9Tcgu4f1rtinj7TvfgmqU3tgK2INh0QBKy3JAV/qY2vr8/0RMo2ttKqxcN1awmL/ftTbMgyIQJdeoU7aG3hWdnVkbJChJ1Hv6V42dj1GDDtzdONr1tXGczdIz8LuJcOkVq9GLGuayD3xHi0ToZMS9GtUZtTSnZ4Fz8/d6u0vjZEt/dShqkqpSEThdWNbE+TniWlWfmBtKfphI2bWawYhPJb1a2a9dnumCB0X6zsETQEtDr0zwWxnvqwOGQey1Mt3W5loTogqHbizWThDPjE8MrQGv2aR7oznpbXiU1exz7FMwQQXOWoxYAAaZr6lJzTo8VMX+e0j56JZdvNjeeaxSDax85MnhIUJfPxoRaOowVrUU=_1_1',
};
